import { render, staticRenderFns } from "./GrowthAreasCard.vue?vue&type=template&id=5c5ecebc"
import script from "./GrowthAreasCard.vue?vue&type=script&lang=js"
export * from "./GrowthAreasCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports